<script>
  import { push } from "svelte-spa-router"
</script>

<section class="page_404">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="col-sm-10 col-sm-offset-1 text-center">
          <div class="four_zero_four_bg mt-6">
            <h1 class="text-center">404</h1>
          </div>

          <div>
            <h3 class="h2">Look like you're lost</h3>

            <p>the page you are looking for not avaible!</p>
            <button
              class="link_404"
              on:click={() => {
                push("/analytics/documents")
              }}
            >
              Go to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<style>
  .four_zero_four_bg {
    background-image: url(https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif);
    height: 400px;
    background-position: center;
    background-repeat: no-repeat;
  }

  .four_zero_four_bg h1 {
    font-size: 80px;
  }

  .link_404 {
    color: #fff !important;
    padding: 10px 20px;
    background: #39ac31;
    border-radius: 5px;
    margin: 20px 0;
    display: inline-block;
  }
</style>
